import React, { createContext, useContext, useState } from 'react'
import type { LocationDebugStatus } from '../hooks/useResourceLocationSender'

const INITIAL: LocationDebugStatus = { status: 'inactive', message: '' }

type SetLocationDebugStatus = (status: LocationDebugStatus) => void

const LocationTrackingDebugContext = createContext<{
  locationDebugStatus: LocationDebugStatus
  setLocationDebugStatus: SetLocationDebugStatus
}>({
  locationDebugStatus: INITIAL,
  setLocationDebugStatus: () => {},
})

export function LocationTrackingDebugProvider({ children }: { children: React.ReactNode }) {
  const [locationDebugStatus, setLocationDebugStatus] = useState<LocationDebugStatus>(INITIAL)
  return (
    <LocationTrackingDebugContext.Provider value={{ locationDebugStatus, setLocationDebugStatus }}>
      {children}
    </LocationTrackingDebugContext.Provider>
  )
}

export function useLocationTrackingDebug() {
  return useContext(LocationTrackingDebugContext)
}
